import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { FormFlow } from '../../../../components/FormFlow/FormFlow';
import { getSpecificActiveEnrolment } from '../../../../selectors/enrolmentSelector';
import { PATH_HUB_HOME } from '../../../../util/pagePath';
import { Confirm } from './Confirm/Confirm';
import { DateAndTimeSelection } from './DateAndTimeSelection/DateAndTimeSelection';
import { Success } from './Success/Success';
import SuccessWithVoucher from './Success/SuccessWithVoucher';

export interface Params {
  enrolmentId?: string;
}

const AddOneOffSession = () => {
  const { enrolmentId } = useParams<Params>();
  const enrolment = useSelector(getSpecificActiveEnrolment({ enrolmentId }));
  const history = useHistory();

  const formElements = {
    '': DateAndTimeSelection,
    '/confirm': Confirm,
    '/success': Success,
    '/success-voucher': SuccessWithVoucher,
  };

  useEffect(() => {
    if (!enrolment) {
      history.push(PATH_HUB_HOME);
    }
  }, [enrolment, history]);

  return <FormFlow elements={formElements} />;
};

export { AddOneOffSession };
